import { Component, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { InlineAlertBanner } from 'app/models/inlineAlertBanner';
import { ConfigService } from 'app/services/config.service';
import { DateUtilsService } from 'app/services/date-utils.service';

@Component({
  selector: 'app-inline-alert-banner',
  templateUrl: './inline-alert-banner.component.html',
  standalone: false,
})
export class InlineAlertBannerComponent implements OnInit {
  inlineAlertBanner?: InlineAlertBanner;
  showBanner = true;

  private renderer: Renderer2;
  private readonly bodyAttr = 'data-has-inline-alert-banner';

  constructor(
    private configService: ConfigService,
    private dateUtilsService: DateUtilsService,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  ngOnInit() {
    this.configService.getConfig('inline-alert-banner').subscribe((response) => {
      const banner = response?.Items?.length ? response.Items[0] : undefined;

      if (!banner) {
        this.inlineAlertBanner = undefined;
        this.showBanner = false;
        this.updateBodyFlag();
        return;
      }

      this.inlineAlertBanner = banner;
      const isExpired = this.dateUtilsService.isExpired(this.inlineAlertBanner.expiryDate);

      if (isExpired) {
        this.inlineAlertBanner = undefined;
        this.showBanner = false;
        this.updateBodyFlag();
        return;
      }

      this.showBanner = true;
      this.updateBodyFlag();
    });
  }

  closeBanner(): void {
    this.showBanner = false;
    this.updateBodyFlag();
  }

  private updateBodyFlag(): void {
    const isVisible = !!(this.showBanner && this.inlineAlertBanner);
    if (isVisible) {
      this.renderer.setAttribute(document.body, this.bodyAttr, 'true');
    } else {
      this.renderer.removeAttribute(document.body, this.bodyAttr);
    }
  }
}
